import React, { FC } from 'react';
import { FamiliesListPage } from './family-list.page';
import { FamilyColumnName } from '../../hooks/table-columns/families-table-columns.hook';
import { AllowedFamilyActions } from '../../components/families-table/families-table-actions.component';

export const FamiliesListAdminLevelPage: FC = () => {
	const familyColumnsList: FamilyColumnName[] = [
		'fullName',
		'email',
		'phoneNumber',
		'location',
		'preferedLanguage',
		'totalEngagements',
		'district',
		'actions',
	];
	const allowedFamilyActions: AllowedFamilyActions[] = ['view', 'delete', 'edit'];
	return <FamiliesListPage permission={{ read: true }} isAdminRoute={true} familyColumnsList={familyColumnsList} allowedFamilyActions={allowedFamilyActions}/>;
};
